const SET_SGIP_IS_VISIBLE = 'SET_SGIP_IS_VISIBLE';

export { SET_SGIP_IS_VISIBLE };



// WEBPACK FOOTER //
// ./src/containers/Inputs/SGIP/constants.js